<template>
    <el-dialog v-dialogDrag :title="title" :visible.sync="show" width="900px">
        <div class="chat-selector">
            <div class="left-box">
                <el-input placeholder="搜索" v-model="searchText">
                    <i class="el-icon-search el-input__icon" slot="suffix"> </i>
                </el-input>
                <div class="select-box">
                    <el-button type="danger" size="mini" plain @click="onClearAll">清空</el-button>
                    <el-button type="primary" size="mini" plain @click="onSelectAll('friend')">全选(好友)</el-button>
                    <el-button type="primary" size="mini" plain @click="onSelectAll('group')">全选(群组)</el-button>
                    <el-button type="primary" size="mini" plain @click="onSelectAll('all')">全选</el-button>
                </div>
                <tabs :items="tabItems" :current="tabIdx" @change="onTabChange"></tabs>
                <virtual-scroller v-if="tabIdx == 0" class="left-scroll-box" :items="showChats" :item-height="60" :item-key="chatSelectKey">
                    <template v-slot="{ item }">
                        <div class="chat-item" @click="onClickChatItem(item)">
                            <head-image :url="item.headImage" :name="item.showName" :size="42"></head-image>
                            <div class="chat-info">
                                <div class="chat-name">{{ item.showName }}
                                    <el-tag v-if="item.type == 'GROUP'" size="mini">群</el-tag>
                                </div>
                                <div class="chat-content" v-html="formatChatContent(item.lastContent)">
                                </div>
                            </div>
                            <el-checkbox v-model="item.checked" class="check-box" @click.native.stop=""
                                @change="onChatChange(item)"></el-checkbox>
                        </div>
                    </template>
                </virtual-scroller>
                <virtual-scroller v-if="tabIdx == 1" class="left-scroll-box" :items="showFriends" :item-height="60" item-key="id">
                    <template v-slot="{ item }">
                        <friend-item @click.native="onClickFriendItem(item)" :menu="false" :friend="item">
                            <el-checkbox :value="isFriendChecked(item.id)" class="check-box" @click.native.stop=""
                                @change="onFriendChange(item)"></el-checkbox>
                        </friend-item>
                    </template>
                </virtual-scroller>
                <virtual-scroller v-if="tabIdx == 2" class="left-scroll-box" :items="showGroups">
                    <template v-slot="{ item }">
                        <div class="group-item-wrapper">
                            <group-item :group="item" @click.native="onClickGroupItem(item)">
                            </group-item>
                            <el-checkbox v-model="item.checked" class="check-box" @click.native.stop=""
                                @change="onGroupChange(item)"></el-checkbox>
                        </div>
                    </template>
                </virtual-scroller>
            </div>
            <div class="arrow el-icon-d-arrow-right"></div>
            <div class="right-box">
                <div class="tip">已选择{{ checkedItems.length }}个联系人</div>
                <el-scrollbar class="right-scroll-box">
                    <div v-for="(item, idx) in checkedItems" :key="idx">
                        <div class="checked-item">
                            <head-image :url="item.headImage" :name="item.showName" :size="42"></head-image>
                            <div class="name">{{ item.showName }}</div>
                            <div class="close" title="移除" @click.stop="onRemoveItem(item)"><i class="el-icon-close"></i>
                            </div>
                        </div>
                    </div>
                </el-scrollbar>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close()">取 消</el-button>
            <el-button type="primary" @click="ok()">发 送</el-button>
        </span>

    </el-dialog>
</template>
<script>
import HeadImage from '../common/HeadImage.vue';
import Tabs from '../common/Tabs.vue';
import VirtualScroller from '../common/VirtualScroller.vue';
import FriendItem from '../friend/FriendItem.vue';
import GroupItem from '../group/GroupItem.vue';
import { formatMessageHtml } from '@/utils/common';

export default {
    components: { VirtualScroller, HeadImage, Tabs, FriendItem, GroupItem },
    name: "chatSelector",
    props: {
        title: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            show: false,
            searchText: "",
            callback: null,
            tabIdx: 0,
            tabItems: ['最近聊天', '好友', '群聊'],
            chats: [],
            friends: [],
            groups: [],
            checkedItems: []
        }
    },
    methods: {
        chatSelectKey(item) {
            return item.type + '-' + item.targetId;
        },
        formatChatContent(content) {
            return formatMessageHtml(content || '', '', 'emoji-small');
        },
        open(callback) {
            this.tabIdx = 0;
            this.searchText = "";
            this.show = true;
            this.callback = callback;
            this.initData();
        },
        initData() {
            this.checkedItems = []
            this.chats = [];
            this.friends = [];
            this.groups = []
            this.$store.state.chatStore.chats.forEach(chat => {
                // 过滤掉掉已经删除好友关系或者退群的会话
                if ((chat.type == 'PRIVATE' && this.$store.getters.isFriend(chat.targetId))
                    || (chat.type == 'GROUP' && this.$store.getters.isGroup(chat.targetId))) {
                    this.chats.push({
                        type: chat.type,
                        targetId: chat.targetId,
                        headImage: chat.headImage,
                        showName: chat.showName,
                        lastContent: chat.lastContent,
                        checked: false
                    })
                }
            })
            this.$store.state.groupStore.groups.forEach(group => {
                if (!group.quit) {
                    this.groups.push({
                        id: group.id,
                        headImage: group.headImage,
                        showGroupName: group.showGroupName,
                        checked: false
                    })
                }
            })
        },
        close() {
            this.show = false;
        },
        ok() {
            if (this.checkedItems.length == 0) {
                this.$message.error("请选择需要转发的好友/群聊");
                return;
            }
            let type = '';
            const friendLength = this.checkedItems.filter(item => item.type == 'PRIVATE').length;
            const groupLength = this.checkedItems.filter(item => item.type == 'GROUP').length;
            const allFriendCount = (this.$store.getters.friendList || []).filter((f) => f && !f.deleted).length;
            const allGroupCount = this.groups.length;
            if (allFriendCount > 0 && friendLength == allFriendCount && allGroupCount > 0 && groupLength == allGroupCount) {
                type = 'all'
            } else if (allFriendCount > 0 && friendLength == allFriendCount && groupLength == 0) {
                type = 'friend'
            } else if (allGroupCount > 0 && groupLength == allGroupCount && friendLength == 0) {
                type = 'group'
            }
            this.close();
            this.callback(this.checkedItems, type);
        },
        onTabChange(idx) {
            this.tabIdx = idx;
            // 更新选中状态
            this.chats.forEach(chat => {
                chat.checked = this.checkedItems.some(chatItem => chat.type == chatItem.type && chat.targetId == chatItem.targetId);
            })
            this.friends.forEach(f => {
                f.checked = this.checkedItems.some(chatItem => chatItem.type == 'PRIVATE' && chatItem.targetId == f.id);
            })
            this.groups.forEach(g => {
                g.checked = this.checkedItems.some(chatItem => chatItem.type == 'GROUP' && chatItem.targetId == g.id);
            })
        },
        onSelectAll(selectType) {
            this.checkedItems = [];
            if (selectType == 'friend' || selectType == 'all') {
                this.listFriends().forEach(friend => {
                    let chatItem = {
                        targetId: friend.id,
                        type: 'PRIVATE',
                        showName: friend.showNickName,
                        headImage: friend.headImage
                    }
                    const set = new Set(this.checkedItems.map(item => JSON.stringify(item)));
                    if (!set.has(JSON.stringify(chatItem))) {
                        this.checkedItems.push(chatItem)
                    }
                })
            }
            if (selectType == 'group' || selectType == 'all') {
                this.showGroups.forEach(group => {
                let chatItem = {
                    targetId: group.id,
                    type: 'GROUP',
                    showName: group.showGroupName,
                    headImage: group.headImage
                }
                const set = new Set(this.checkedItems.map(item => JSON.stringify(item)));
                if (!set.has(JSON.stringify(chatItem))) {
                    this.checkedItems.push(chatItem)
                }
            })
            }
            this.onTabChange(this.tabIdx);
        },
        onClearAll() {
            this.checkedItems = [];
            this.onTabChange(this.tabIdx);
        },
        onClickChatItem(chatItem) {
            chatItem.checked = !chatItem.checked;
            this.onChatChange(chatItem);
        },
        onChatChange(chatItem) {
            let idx = this.checkedItems.findIndex(chat => chat.type == chatItem.type && chat.targetId == chatItem.targetId);
            if (idx >= 0) {
                this.checkedItems.splice(idx, 1)
            } else {
                this.checkedItems.push(chatItem)
            }
        },
        onClickFriendItem(friend) {
            this.onFriendChange(friend);
        },
        onFriendChange(friend) {
            let idx = this.checkedItems.findIndex(chat => chat.type == 'PRIVATE' && chat.targetId == friend.id);
            if (idx >= 0) {
                this.checkedItems.splice(idx, 1)
            } else {
                let chatItem = {
                    targetId: friend.id,
                    type: 'PRIVATE',
                    showName: friend.showNickName,
                    headImage: friend.headImage
                }
                this.checkedItems.push(chatItem)
            }
        },
        onClickGroupItem(group) {
            group.checked = !group.checked;
            this.onGroupChange(group);
        },
        onGroupChange(group) {
            let idx = this.checkedItems.findIndex(chat => chat.type == 'GROUP' && chat.targetId == group.id);
            if (idx >= 0) {
                this.checkedItems.splice(idx, 1)
            } else {
                let chatItem = {
                    targetId: group.id,
                    type: 'GROUP',
                    showName: group.showGroupName,
                    headImage: group.headImage
                }
                this.checkedItems.push(chatItem)
            }
        },
        onRemoveItem(chatItem) {
            let idx = this.checkedItems.findIndex(chat => chat.type == chatItem.type && chat.targetId == chatItem.targetId);
            this.checkedItems.splice(idx, 1);
            // 取消选中状态
            let chat = this.chats.find(chat => chat.type == chatItem.type && chat.targetId == chatItem.targetId);
            if (chat) {
                chat.checked = false;
            }
            if (chatItem.type == 'PRIVATE') {
                return;
            }
            if (chatItem.type == 'GROUP') {
                let group = this.groups.find(g => g.id == chatItem.targetId);
                if (group) {
                    group.checked = false;
                }
            }
        },
        isFriendChecked(id) {
            return this.checkedItems.some(item => item.type == 'PRIVATE' && item.targetId == id);
        },
        listFriends() {
            const keyword = this.searchText || '';
            const friends = this.$store.getters.friendList || [];
            const out = [];
            for (let i = 0; i < friends.length; i++) {
                const friend = friends[i];
                if (!friend || friend.deleted) {
                    continue;
                }
                if (keyword && !(friend.showNickName || '').includes(keyword)) {
                    continue;
                }
                out.push(friend);
            }
            return out;
        }
    },
    computed: {
        showChats() {
            return this.chats.filter(chat => (chat.showName || '').includes(this.searchText))
        },
        showFriends() {
            if (!this.show || this.tabIdx != 1) {
                return [];
            }
            this.$store.state.friendStore.friendsVersion;
            return this.listFriends();
        },
        showGroups() {
            return this.groups.filter(g => (g.showGroupName || '').includes(this.searchText))
        },
    }
}
</script>

<style scoped lang="scss">
.chat-selector {
    display: flex;
    .left-box {
        width: 48%;
        overflow: hidden;
        border: var(--im-border);
        .select-box {
            margin: 12px 0;
            text-align: right;
        }
        .el-input__inner {
            border: none;
            border-bottom: var(--im-border);
        }

        .left-scroll-box {
            height: 400px;

            .check-box {
                margin-right: 10px;
            }
            .group-item-wrapper {
                display: flex;
                justify-content: space-between;
                padding-right: 10px;
                &:hover {
                    background-color: var(--im-background-active);
                }
            }
            .chat-item {
                display: flex;
                align-items: center;
                padding: 5px 10px;
                cursor: pointer;

                .chat-info {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    padding-left: 10px;
                    text-align: left;
                    overflow: hidden;

                    .chat-name {
                        flex: 1;
                        white-space: nowrap;
                        overflow: hidden;
                        display: flex;
                        align-items: center;

                        .el-tag {
                            min-width: 20px;
                            text-align: center;
                            border-radius: 10px;
                            border: 0;
                            margin-left: 3px;
                        }
                    }

                    .chat-content {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        font-size: var(--im-font-size-small);
                        color: var(--im-text-color-light);
                    }
                }

                &:hover {
                    background-color: var(--im-background-active);
                }
            }
        }
    }

    .arrow {
        display: flex;
        align-items: center;
        font-size: 20px;
        padding: 10px;
        color: var(--im-color-primary);
    }

    .right-box {
        width: 48%;
        border: var(--im-border);

        .tip {
            text-align: left;
            height: 40px;
            line-height: 40px;
            text-indent: 10px;
            color: var(--im-text-color-light)
        }

        .right-scroll-box {
            height: 460px;

            .checked-item {
                display: flex;
                align-items: center;
                padding: 5px 10px;
                white-space: nowrap;
                cursor: pointer;

                .name {
                    margin-left: 10px;
                    flex: 1;
                    text-align: left;
                    overflow: hidden;
                }

                .close {
                    width: 30px;
                    display: none;
                }

                &:hover {
                    background-color: var(--im-background-active);
                }

                &:hover .close {
                    display: block;
                }
            }
        }
    }
}
</style>
